export function getCurrentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function getMonthKey(dateValue) {
  if (!dateValue) return null;

  if (typeof dateValue === 'string') {
    const normalized = dateValue.trim();
    const directMatch = normalized.match(/^(\d{4})-(\d{2})/);
    if (directMatch) {
      return `${directMatch[1]}-${directMatch[2]}`;
    }
  }

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

export function formatMonthLabel(monthKey) {
  if (!monthKey) return '';

  const [year, month] = monthKey.split('-').map(Number);
  const date = new Date(year, month - 1, 1);

  return date.toLocaleDateString('pt-BR', {
    month: 'short',
    year: 'numeric',
  }).replace('.', '');
}

function sortMonthKeysDesc(monthKeys) {
  return [...monthKeys].sort((a, b) => b.localeCompare(a));
}
export function buildMonthOptions(dateValues = []) {
  const keys = dateValues
    .map((value) => getMonthKey(value))
    .filter(Boolean);

  const uniqueKeys = Array.from(new Set(keys));
  const merged = sortMonthKeysDesc(uniqueKeys);

  return merged.map((key) => ({
    value: key,
    label: formatMonthLabel(key),
  }));
}

export function matchesSelectedMonths(dateValue, selectedMonths = []) {
  if (!selectedMonths || selectedMonths.length === 0) {
    return true;
  }

  const monthKey = getMonthKey(dateValue);
  return selectedMonths.includes(monthKey);
}

export function countDistinct(values = []) {
  return new Set(values.filter((value) => value !== null && value !== undefined && value !== '')).size;
}
